import { gsap } from "gsap";

export default function initMobileNav() {
  const mobileNavOpen = document.getElementById("mobile_nav_open");
  const mobileNavClose = document.getElementById("mobile_nav_close");
  const headerMenu = document.getElementById("header_menu");

  if (!mobileNavOpen || !mobileNavClose || !headerMenu) return;

  // Initialize GSAP timelines
  const openTimeline = gsap.timeline({ paused: true });
  const closeTimeline = gsap.timeline({ paused: true });

  // Setup open animation
  openTimeline
    .set(headerMenu, { display: "block", opacity: 0 })
    .to(headerMenu, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    })
    .from(
      headerMenu.querySelectorAll("li"),
      {
        y: -20,
        opacity: 0,
        stagger: 0.05,
        duration: 0.4,
        ease: "back.out(1.7)",
      },
      "-=0.1"
    );

  // Setup close animation
  closeTimeline
    .to(headerMenu, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
    })
    .set(headerMenu, { display: "none" });

  mobileNavOpen.addEventListener("click", () => {
    document.body.classList.add("nav-open");
    headerMenu.classList.add("is-active");

    // Play open animation
    closeTimeline.pause(0);
    openTimeline.restart();
  });

  mobileNavClose.addEventListener("click", () => {
    // Play close animation, then remove classes when complete
    openTimeline.pause();
    closeTimeline.restart().eventCallback("onComplete", () => {
      headerMenu.classList.remove("is-active");
      document.body.classList.remove("nav-open");
    });
  });

  // Close menu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      headerMenu.classList.contains("is-active") &&
      !headerMenu.contains(e.target) &&
      !mobileNavOpen.contains(e.target) &&
      !mobileNavClose.contains(e.target)
    ) {
      // Play close animation, then remove classes when complete
      openTimeline.pause();
      closeTimeline.restart().eventCallback("onComplete", () => {
        headerMenu.classList.remove("is-active");
        document.body.classList.remove("nav-open");
      });
    }
  });
}
